import { createSelector } from '@ngrx/store';
import { AppState } from './app.state';
import { MediaPlayerCurrentState } from './objects/media-player/media-player-current-state';
import { RadioAPI } from './objects/radio-api';
import { SearchState } from './objects/search-state';

export const selectStaticMediaPlayerCurrentState = (state: AppState) =>
  state.staticMediaPlayerCurrentState;

export const selectStaticMediaPlayerSelector = createSelector(
  selectStaticMediaPlayerCurrentState,
  (state: MediaPlayerCurrentState) => state
);

export const selectAllRadios = (state: AppState) => state.allRadios;

export const selectAllRadiosSelector = createSelector(
  selectAllRadios,
  (state: Array<RadioAPI>) => state
);

export const selectSearchState = (state: AppState) => state.searchState;

export const selectSearchStateSelector = createSelector(
  selectSearchState,
  (state: SearchState) => state
);

export const selectUserCountryCode = (state: AppState) => state.userCountryCode;

export const selectUserCountryCodeSelector = createSelector(
  selectUserCountryCode,
  (state: string) => state
);

export const selectSuggestedRadios = (state: AppState) => state.suggestedRadios;

export const selectSuggestedRadiosSelector = createSelector(
  selectSuggestedRadios,
  (state: Array<RadioAPI>) => state
);

